import styled from 'styled-components';
import EasyAccessSvg from '../../../assets/onboarding/newHome/easy-access.svg';

const EasyAccessIcon = styled(EasyAccessSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`

width: ${props => props.width || '4.2rem'};
height: ${props => props.height || '4.2rem'};
display: flex;
`;

export default EasyAccessIcon;
